import React, { useEffect } from "react";
import AOS from "aos";
import { Link } from "react-router-dom";
import "aos/dist/aos.css";
import { motion } from "framer-motion";
import Button from "../components/Button";
import videoSrc from "../Assest/videos/aboutPageVideo.mp4"; // Isko aap bad mei apni grocery/appliance video se replace kar sakte hain
import img2 from "../Assest/images/homeEssential.jpg";

function Aboutus() {
  useEffect(() => {
    AOS.init({ duration: 1000 });
  }, []);

  return (
    <div className="w-full mx-auto overflow-hidden pt-[6rem]">
      
      {/* Hero Section */}
   <section className="relative w-full h-[500px] overflow-hidden">
  <motion.div
    initial={{ opacity: 0, y: 50 }}
    whileInView={{ opacity: 1, y: 0 }}
    viewport={{ once: true, margin: "-100px" }}
    transition={{ duration: 0.8 }}
    className="w-full h-full"
  >
    <video
      src={videoSrc}
      autoPlay
      loop
      muted
    
      className="absolute top-0 left-0 w-full h-full object-cover blur-sm scale-105"
    />
    <div className="absolute inset-0 bg-black opacity-40"></div>
    <div className="absolute bottom-10 left-10 text-white">
      <h1 className="text-4xl md:text-6xl font-bold">About Our Store</h1>
    </div>
  </motion.div>
</section>

      {/* About Section 1: Introduction */}
      <section className="relative py-20 md:py-32">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap -mx-4 items-center">
            {/* Content Column */}
            <div
              className="w-full lg:w-1/2 px-4 mb-10 lg:mb-0"
              data-aos="flip-right"
            >
              <div className="lg:pr-12">
                <div className="mb-8">
                  <div className="relative text-orange-500 text-lg font-bold mb-4 inline-block pr-12">
                    About Vital Source
                    <span className="absolute right-0 bottom-2 w-10 h-[1px] bg-gray-400"></span>
                  </div>
                  <h2 className="text-3xl md:text-4xl font-bold leading-tight text-gray-800">
                    We Are The Leader In <br /> Home Essentials & Appliances
                  </h2>
                </div>
                <p className="text-gray-600 text-base leading-relaxed mb-8">
                  At Vital Source, we are committed to making your daily life easier and more comfortable. We specialize in providing high-quality electronic home appliances and premium everyday household essentials. From reliable kitchen electronics to your daily home utilities, we ensure everything you need is just a click away.
                </p>
                <div className="text-gray-900 font-bold mb-8">
                  Get a Quote / Inquiry:{" "}
                  <span className="text-orange-500">info@vitalsourcewholesalellc.com</span>
                </div>
                <Link
                  to="/products"
                  className="relative inline-block px-10 py-3 text-gray-900 text-sm font-bold 
                  bg-white border-2 border-orange-500 hover:bg-orange-500 hover:text-white 
                  transition-all duration-300 group"
                >
                  <span className="relative z-10">Shop Now</span>
                  <div
                    className="absolute left-2 top-2 -right-2 -bottom-2 bg-gray-100 
                    transition-all duration-300 -z-10 group-hover:bg-orange-500/20"
                  ></div>
                </Link>
              </div>
            </div>

            {/* Image Column */}
            <div className="w-full lg:w-1/2 px-4 mb-12" data-aos="flip-left">
              <div className="relative p-4 md:pl-12">
                <div className="absolute right-0 top-0 left-4 md:left-10 bottom-12 border-2 border-orange-500 -z-10"></div>
                <div className="relative">
                  <img src={img2} alt="Our Store" className="w-full rounded-lg" />
                  
                  {/* Experience Box */}
                  <div className="absolute left-4 bottom-6 md:left-10 bg-white p-4 border border-gray-200 shadow-md rounded-lg">
                    <div className="text-gray-900 text-sm md:text-lg font-bold flex items-center gap-3">
                      <span className="text-orange-500 text-3xl md:text-4xl font-bold">5+</span>
                      Years of <br /> Trusted <br /> Service
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* About Section 2: Core Values */}
      <section className="py-20 md:py-32 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="flex flex-wrap -mx-4 items-center">
            {/* Content Column */}
            <div
              className="w-full lg:w-1/2 px-4 mb-12 lg:order-2"
              data-aos="fade-left"
            >
              <div className="lg:pl-8">
                <div className="mb-8">
                  <span className="block text-orange-500 text-lg font-medium mb-4">
                    Premium Quality Only
                  </span>
                  <h2 className="text-3xl md:text-4xl text-gray-800 font-semibold mb-4 relative pb-4 after:content-[''] after:absolute after:left-0 after:bottom-0 after:w-12 after:h-[3px] after:bg-orange-500">
                    Bringing Convenience To Your Doorstep
                  </h2>
                </div>

                <p className="text-gray-600 text-base leading-7 mb-5">
                  We take pride in sourcing authentic home appliances and daily household essentials from trusted brands. Whether you are upgrading your kitchen with modern electronics or stocking up on monthly household utilities, our strict quality checks guarantee complete reliability.
                </p>

                <p className="text-gray-600 text-base leading-7 mb-8">
                  Please note that we focus purely on smart home electronics, appliances, and long-lasting non-perishable essentials—ensuring that everything you buy from us is highly durable and comes with full brand assurance.
                </p>

                <div>
                  <Link
                    to="/products"
                    className="inline-block px-8 py-4 bg-orange-500 hover:bg-orange-600 
                    text-white text-lg font-semibold transition-colors duration-300 rounded shadow-md"
                  >
                    Explore Our Categories
                  </Link>
                </div>
              </div>
            </div>

            {/* Image Column */}
            <div className="w-full lg:w-1/2 px-4 mb-12 lg:order-1" data-aos="fade-right">
              <div className="relative p-6 overflow-hidden max-w-full">
                <div className="absolute w-[80%] h-[90%] top-0 left-0 z-0 border-[16px] md:border-[24px] border-orange-500/20 rounded-2xl"></div>

                {/* Store Management / Quality Assurance Tag */}
                <div className="absolute bottom-10 left-12 z-10 bg-orange-500 py-2.5 px-6 rounded-full shadow-lg">
                  <h2 className="text-base md:text-lg text-white text-center font-semibold m-0">
                    100% Authentic Products
                  </h2>
                </div>

                <figure className="relative z-10 p-4">
                  <img
                    src={img2}
                    alt="Premium Store Goods"
                    className="rounded-[24px] shadow-lg w-full object-cover"
                  />
                </figure>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Customer Testimonials */}
      <section className="text-center py-16 px-6 md:px-20 bg-white">
        <h2 className="text-3xl font-semibold mb-6" data-aos="fade-up">
          What Our Customers Say
        </h2>
        <p className="text-gray-750 max-w-xl mx-auto italic text-lg" data-aos="zoom-in">
          "Fantastic experience! I bought a smart blender and some monthly household supplies. The packaging was immaculate, appliances had official warranties, and delivery was exceptionally fast."
        </p>
        <p className="text-gray-600 font-semibold mt-4">- Sarah Williams</p>
      </section>

      {/* Contact Section */}
      <section className="text-center py-16 px-6 md:px-20 bg-gray-50">
        <h2 className="text-3xl font-semibold mb-6" data-aos="fade-up">
          Have Questions About Our Products?
        </h2>
        <p className="text-gray-700 mb-6 max-w-md mx-auto">
          Want to know more about product warranties, delivery timings, or bulk orders? Feel free to contact us.
        </p>
        <Link to="/contact">
          <Button text="Contact Us" />
        </Link>
      </section>
    </div>
  );
}

export default Aboutus;